import { Button } from 'components'
import './style.scss'

export function ActionContainer({
  onConfirm,
  labelConfirm,
  onBack,
  isLoading = false,
  disabled = false,
}) {
  return (
    <div className='action-container'>
      <Button
        color='primary'
        size='large'
        className='button-confirm'
        onClick={onConfirm}
        isLoading={isLoading}
        disabled={disabled}
      >
        {labelConfirm}
      </Button>
      <Button
        color='outline'
        size='large'
        className='button-back'
        onClick={onBack}
        isLoading={isLoading}
      >
        Voltar
      </Button>
    </div>
  )
}
